import React, { useState } from 'react';
import { ArrowUp, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  return <>
      <footer className="bg-[#FDF4FF] py-12 border-t border-[#F5D0FE]" data-id="element-118">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-120">
            <div className="text-center md:text-left" data-id="element-121">
              <h4 className="font-bold text-[#2D2D2D] mb-2" data-id="element-122">Bowl Upgrade</h4>
              <p className="text-sm text-[#666666]" data-id="element-123">
                Este plan no reemplaza al veterinario.
              </p>
            </div>

            <button onClick={scrollToTop} className="flex items-center text-sm font-medium text-[#D946EF] hover:text-[#C026D3] transition-colors" data-id="element-124">
              Volver arriba
              <ArrowUp className="w-4 h-4 ml-2" data-id="element-125" />
            </button>
          </div>

          <div className="mt-8 pt-8 border-t border-[#F5D0FE]/50 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-126">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-[#666666] hover:text-[#D946EF] transition-colors" data-id="element-127">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-[#666666] hover:text-[#D946EF] transition-colors" data-id="element-128">
              Términos y Condiciones
            </button>
          </div>

          <div className="mt-6 text-center text-xs text-gray-400" data-id="element-129">
            © {new Date().getFullYear()} Bowl Upgrade. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-130">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={closeModal} data-id="element-131">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-132">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-133">
                <h2 className="text-xl font-bold text-[#2D2D2D]" data-id="element-134">
                  {activeModal === 'privacy' && 'Política de Privacidad'}
                  {activeModal === 'terms' && 'Términos y Condiciones'}
                </h2>
                <button onClick={closeModal} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-135">
                  <X className="w-5 h-5 text-gray-500" data-id="element-136" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[60vh] text-sm text-[#666666] space-y-4" data-id="element-137">
                {activeModal === 'privacy' ? <>
                    <p className="font-semibold text-[#2D2D2D]" data-id="element-138">
                      Última actualización: Enero 2026
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-139">
                      1. Información que Recopilamos
                    </h3>
                    <p data-id="element-140">
                      Recopilamos información que nos proporcionas directamente,
                      como tu nombre, correo electrónico y datos de pago cuando
                      realizas una compra. También podemos recopilar información
                      sobre tu dispositivo y cómo interactúas con nuestro sitio.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-141">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-142">Utilizamos la información recopilada para:</p>
                    <ul className="list-disc pl-5 space-y-1" data-id="element-143">
                      <li data-id="element-144">
                        Procesar tus pedidos y enviarte el contenido adquirido
                      </li>
                      <li data-id="element-145">Enviarte actualizaciones sobre tu compra</li>
                      <li data-id="element-146">Mejorar nuestros productos y servicios</li>
                      <li data-id="element-147">
                        Comunicarnos contigo sobre ofertas y novedades (si lo
                        autorizas)
                      </li>
                    </ul>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-148">
                      3. Protección de Datos
                    </h3>
                    <p data-id="element-149">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, pérdida o alteración.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-150">
                      4. Compartir Información
                    </h3>
                    <p data-id="element-151">
                      No vendemos ni compartimos tu información personal con
                      terceros, excepto cuando sea necesario para procesar pagos
                      o cumplir con obligaciones legales.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-152">
                      5. Tus Derechos
                    </h3>
                    <p data-id="element-153">
                      Tienes derecho a acceder, rectificar o eliminar tu
                      información personal. Para ejercer estos derechos,
                      contáctanos a través de nuestro correo electrónico.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-154">
                      6. Contacto
                    </h3>
                    <p data-id="element-155">
                      Si tienes preguntas sobre esta política de privacidad,
                      puedes contactarnos en: contacto@bowlupgrade.com
                    </p>
                  </> : <>
                    <p className="font-semibold text-[#2D2D2D]" data-id="element-156">
                      Última actualización: Enero 2026
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-157">
                      1. Aceptación de los Términos
                    </h3>
                    <p data-id="element-158">
                      Al acceder y utilizar este sitio web y adquirir nuestros
                      productos, aceptas estos términos y condiciones en su
                      totalidad. Si no estás de acuerdo con alguna parte, no
                      debes usar nuestros servicios.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-159">
                      2. Productos y Servicios
                    </h3>
                    <p data-id="element-160">
                      Bowl Upgrade ofrece contenido digital educativo sobre
                      nutrición canina. Nuestros productos son guías
                      informativas y no sustituyen el consejo veterinario
                      profesional.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-161">
                      3. Proceso de Compra
                    </h3>
                    <p data-id="element-162">
                      Al realizar una compra, recibirás acceso inmediato al
                      contenido digital adquirido. Los precios están expresados
                      en la moneda indicada e incluyen los impuestos aplicables.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-163">
                      4. Política de Reembolso
                    </h3>
                    <p data-id="element-164">
                      Ofrecemos una garantía de satisfacción. Si no estás
                      conforme con tu compra, puedes solicitar un reembolso
                      dentro de los 7 días posteriores a la compra, sin
                      necesidad de justificación.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-165">
                      5. Propiedad Intelectual
                    </h3>
                    <p data-id="element-166">
                      Todo el contenido de Bowl Upgrade, incluyendo textos,
                      imágenes, guías y materiales, está protegido por derechos
                      de autor. No está permitida la reproducción, distribución
                      o reventa sin autorización expresa.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-167">
                      6. Limitación de Responsabilidad
                    </h3>
                    <p data-id="element-168">
                      Bowl Upgrade proporciona información educativa general. No
                      nos hacemos responsables por resultados específicos, ya
                      que cada mascota es única. Siempre consulta con un
                      veterinario para decisiones de salud.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-169">
                      7. Modificaciones
                    </h3>
                    <p data-id="element-170">
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento. Los cambios entrarán en vigor
                      inmediatamente después de su publicación en el sitio.
                    </p>

                    <h3 className="font-bold text-[#2D2D2D] mt-4" data-id="element-171">
                      8. Contacto
                    </h3>
                    <p data-id="element-172">
                      Para cualquier consulta sobre estos términos, contáctanos
                      en: contacto@bowlupgrade.com
                    </p>
                  </>}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-173">
                <button onClick={closeModal} className="w-full py-3 px-4 bg-[#D946EF] text-white font-semibold rounded-xl hover:bg-[#C026D3] transition-colors" data-id="element-174">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}